import { styled } from 'styled-components';

export const TooltipBody = styled.div`
  max-width: 200px;
  padding: ${({ theme }) => theme.sizing.small}
    ${({ theme }) => theme.sizing.regular};
  background-color: ${({ theme }) => theme.colours.canvas.tertiary.main};
  box-shadow: ${({ theme }) => theme.effects.dropShadow.regular};
  max-height: 270px;
  overflow-y: auto;

  p {
    margin-bottom: ${({ theme }) => theme.sizing.small};
    pointer-events: none;
  }

  p:last-child {
    margin-bottom: 0;
  }
`;
TooltipBody.displayName = 'TooltipBody';

export const TooltipContent = styled.div`
  display: inline;
  svg {
    display: inline;
    margin-left: ${({ theme }) => theme.sizing.tiny};
    padding-bottom: ${({ theme }) => theme.sizing.xtiny};
  }
`;
TooltipContent.displayName = 'TooltipContent';

export const TooltipInline = styled.span`
  display: inline-flex;
  position: relative;
  top: 2px;
  left: 3px;
`;
TooltipInline.displayName = 'TooltipInline';
